export const GET_CSAT_SURVEY = 'GET_CSAT_SURVEY';
export const SET_CSAT_SURVEY = 'SET_CSAT_SURVEY';

export const CSAT_SURVEY     = 'CSAT_SURVEY';
